<template>
  <p class="d-flex align-items-center gap-1 mb-0" :class="{'p-0': !hasLabel, 'p-2': hasLabel}">
    <span v-if="hasLabel" class="label_copy">{{label}}: </span>
    <p
        class="mb-0"
        :class="{ 'has_label_text': hasLabel || isHighlighted, 'no_label_text': !hasLabel }"
        v-if="checkValid"
        >
        {{ !isInvalid(copyValue) ? (copyValue.length > 20 && truncate ? copyValue.slice(0, 20) + "..." : copyValue) : 'NA' }}
    </p>
    <p class="mb-0" :class="{'has_label_text': hasLabel || isHighlighted, 'no_label_text': !(hasLabel || isHighlighted), 'isPaymentPage': isPaymentPage}" v-else>{{ copyValue.length > 20 && truncate ? copyValue.slice(0, 20) + "..." : copyValue }}</p>
    <div class="copy_container ml-2" v-if="!isInvalid(copyValue)">
        <img src="@/assets/images/copy-icon.svg" class="copy-icon " @click="copyToClipboard(copyValue)" v-if="!copySuccess"/>
        <img src="@/assets/images/accept.png" class="copy-icon-tick m-0 p-0" v-if="copySuccess" />
        <p class="copy_tooltip px-2 py-1 rounded">{{ !copySuccess ? 'Copy' : 'Copied' }}</p>
    </div>
    </p>
</template>

<script>
export default {
    name: "CopyToClipboard",
    props: ["label", "copyValue", "checkValid", "hasLabel", "truncate", "isHighlighted"],
    data(){
        return{
            copySuccess: false,
            pageUrl: ""
        }
    },
    computed: {
        isPaymentPage() {
            return this.$route.path.includes('payment');
        }
    },
    methods: {
        copyToClipboard(copytext){
            navigator.clipboard.writeText(copytext)
            .then(() => {
            this.copySuccess = true;
            setTimeout(() => {
                this.copySuccess = false;
            }, 2000);
            })
            .catch(err => console.error("Failed to copy text: ", err));
        },
        isInvalid(value) {
            const trimmed = typeof value === 'string' ? value.trim().toLowerCase() : value;
            return (
                trimmed === null ||
                trimmed === undefined ||
                trimmed === false ||
                trimmed === 0 ||
                trimmed === '' ||
                trimmed === 'null' ||
                trimmed === 'undefined' ||
                trimmed === 'false' ||
                (Array.isArray(trimmed) && trimmed.length === 0) ||
                (typeof trimmed === 'object' && !Array.isArray(trimmed) && Object.keys(trimmed).length === 0)
            );
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/distributorVariables/variable.scss";
    .copy_container{
        img:not(.copy-icon-tick){
            transform: scale(1.1) !important;
        }
    }
    .has_label_text{
        color: $main-bg !important;
    }
    .no_label_text{
        color: $text-color !important;
    }
    .dark{
        .no_label_text{
            color: $base-dark-text !important;
        }
        .has_label_text,
        .isPaymentPage{
            color: $main-bg !important;
        }
        .label_copy{
            color: $base-dark-text !important;
        }
    }
</style>